import { getFirestore, doc, setDoc, getDoc } from 'firebase/firestore';

export const CURRENT_POLICY_VERSION = '1.0';

export async function getPolicyAgreement(userId: string) {
  const db = getFirestore();
  const snap = await getDoc(doc(db, 'users', userId, 'meta', 'policy'));
  return snap.exists() ? snap.data() : null;
}

export async function savePolicyAgreement(userId: string): Promise<void> {
  const db = getFirestore();
  await setDoc(doc(db, 'users', userId, 'meta', 'policy'), {
    agreedVersion: CURRENT_POLICY_VERSION,
    agreedAt: new Date().toISOString(),
  });
}

export function needsPolicyAgreement(agreement: Record<string, any> | null): boolean {
  return !agreement || agreement.agreedVersion !== CURRENT_POLICY_VERSION;
}
